import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  box-sizing: border-box;
`;

export const SettingSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ButtonSection = styled.div`
  height: 40px;
  display: flex;
  align-items: center;
  white-space: nowrap;
  margin-top: auto;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
`;

export const TimeContainer = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 8px;
`;

export const TimeDropdownContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 160px;
  align-items: flex-start;
  box-sizing: border-box;
  overflow-y: scroll;
  position: absolute;
  top: 48px;
  z-index: 200;

  border-radius: 0px 0px 8px 8px;
  background: white;

  box-shadow: var(--alias-style-shadow-strong);
`;

export const TimeDropdownItem = styled.div`
  display: flex;
  padding: 8px 12px;
  align-items: center;
  align-self: stretch;

  &:hover {
    background-color: var(--component-color-fill-normal);
  }
`;

export const InputForm = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
`;